import { Component, OnInit, AfterViewInit, Input } from "@angular/core";
import { icons } from "../../../../environments/config";
import { SlotService } from "src/app/services/slot/slot.service";
import { StoresService } from "src/app/services/catalog/stores.service";
import { DomSanitizer, Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { MatIconRegistry } from "@angular/material/icon";
import { getQueryParam } from "src/app/features/liveshop/utils/helpers";
@Component({
  selector: "app-order-link-footer",
  templateUrl: "./order-link-footer.component.html",
  styleUrls: ["./order-link-footer.component.scss"],
})
export class OrderLinkFooterComponent implements OnInit, AfterViewInit {
  @Input() fromPDP;
  @Input() isEmbedded;
  @Input() is3D;
  @Input() isSTL;
  @Input() isHeaderAndFooter;
  @Input() isRoomPlanner;
  @Input() isthreedPdp;
  @Input() isBusinessUser;
  public whiteShopLogo = icons.whiteShopIcon.icon;
  public fbLogo = icons.footerIcons.fb;
  public isCollectionBoard = false;
  public linkedInLogo = icons.footerIcons.linkedIn;
  public instagramLogo = icons.footerIcons.instagram;
  public youTubeLogo = icons.footerIcons.youTube;
  public twitterLogo = icons.footerIcons.twitter;
  public fbFooterLogoColored = icons.footerIcons.fbFooterColored;
  public linkedInFooterLogoColored = icons.footerIcons.linkedInFooterColored;
  public instagramFooterLogoColored = icons.footerIcons.instagramFooterColored;
  public youTubeFooterLogoColored = icons.footerIcons.youTubeFooterColored;
  public twitterFooterLogoColored = icons.footerIcons.twitterFooterColored;
  public faceBookLink;
  public twitterLink;
  public instaGramLink;
  public youTubeLink;
  public linkedInLink;
  public footerText;
  public addresses;
  public pageLinks;
  public shopConnectLogo = icons.whiteShopIcon.icon;
  public shopConnectLogoWhite = icons.whiteShopIcon.icon_white;
  public emailAddress;
  public isAlternateFooter;
  public contactNumber;
  public seoContent;
  public mapUrl;
  public footerContent;
  currentBusinessUnit: any;
  constructor(
    public slotService: SlotService,
    public router: Router,
    public storesService: StoresService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {}
  setMapUrl(businessUnit) {
    //using directly address of bussiness unit in map as discussed with Omkar and Sathish Kumar
    if (
      businessUnit?.addresses?.length &&
      businessUnit.addresses[0]?.addressLine
    ) {
      let urlMap =
        "https://maps.google.com/maps?q=" +
        businessUnit.addresses[0].addressLine.replaceAll(" ", "%20") +
        "&t=&z=19&ie=UTF8&iwloc=&output=embed";
      this.mapUrl = this.sanitizer.bypassSecurityTrustResourceUrl(urlMap);
    }
  }
  setMailLink(mail?) {
    var mailLink;
    mail
      ? (mailLink = "mailto:" + mail + "?subject=subject text")
      : (mailLink = "mailto:" + this.emailAddress + "?subject=subject text");
    return mailLink;
  }
  setPhoneLink(number?) {
    var phoneLink;
    number
      ? (phoneLink = "tel:" + number)
      : (phoneLink = "tel:" + this.contactNumber);
    return phoneLink;
  }
  linkGenerator(valueText?, isfooter?) {
    var extractedEmail: string[] = valueText?.match(
      /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi
    );
    var text = valueText;
    extractedEmail?.forEach((element) => {
      var linkStartPos = text.indexOf(element);
      var linkEndPos = linkStartPos + element.length;
      let previousText = text.slice(0, linkStartPos);
      let linkText = text.slice(linkStartPos, linkEndPos);
      let afterLinkText = text.substr(linkEndPos + 1);
      text =
        previousText +
        `<a style="color: gray !important;text-decoration: none !important;" href=mailto:${element}?subject=subject text>${linkText}</a> ` +
        afterLinkText;
    });
    valueText = text;
    var extractedPhoneNo: string[] = valueText?.match(/\b\d{10,11}\b/gi);
    var number = valueText;
    extractedPhoneNo?.forEach((element) => {
      var linkStartPos = number.indexOf(element);
      var linkEndPos = linkStartPos + element.length;
      let previousText = number.slice(0, linkStartPos);
      let linkText = number.slice(linkStartPos, linkEndPos);
      let afterLinkText = number.substr(linkEndPos + 1);
      number =
        previousText +
        `<a style="color: gray !important;text-decoration: none !important;" href=tel:${element}>${linkText}</a> ` +
        afterLinkText;
    });
    valueText = number;
    if (isfooter) {
      let footerElements = document.getElementsByClassName("footer-text-class");
      if (footerElements?.length) {
        for (var i = 0; i < footerElements.length; i++) {
          footerElements[i].innerHTML = valueText;
        }
      }
    } else {
      if (this.isAlternateFooter) {
        let addressAlternateElements = document.getElementsByClassName(
          "address-text-alternate-class"
        );
        if (addressAlternateElements?.length) {
          for (var i = 0; i < addressAlternateElements.length; i++) {
            addressAlternateElements[i].innerHTML = valueText;
          }
        }
      } else {
        let addressElements = document.getElementsByClassName(
          "address-text-class"
        );
        if (addressElements?.length) {
          for (var i = 0; i < addressElements.length; i++) {
            addressElements[i].innerHTML = valueText;
          }
        }
      }
    }
  }

  ngOnInit(): void {
    let companyConfig = JSON.parse(localStorage.getItem("companyConfig"));
    this.isCollectionBoard =
      getQueryParam("typeName", this.router) === "Collection Board";
    let businessUnit = JSON.parse(
      sessionStorage.getItem("currentBusinessUnit")
    );
    this.setupConfig(businessUnit.settings.whiteshop, companyConfig);
    let config = JSON.parse(
      localStorage.getItem("busConfig")
        ? localStorage.getItem("busConfig")
        : localStorage.getItem("companyConfig")
        ? localStorage.getItem("companyConfig")
        : localStorage.getItem("config")
    );
    if (config) {
      this.footerText = config.whiteshop.footerText;
      this.addresses =
        config.whiteshop.addresses && config.whiteshop.addresses.length > 3
          ? config.whiteshop.addresses.splice(0, 3)
          : config.whiteshop.addresses;
      this.pageLinks = config.whiteshop.pageLinks;
      if (config.whiteshop.companyLogo && config.whiteshop.companyLogo.length) {
        this.whiteShopLogo = config.whiteshop.companyLogo;
      }
      this.faceBookLink =
        config && config.channels && config.channels.facebookUrl
          ? config.channels.facebookUrl
          : "";
      this.twitterLink =
        config && config.channels && config.channels.twitterUrl
          ? config.channels.twitterUrl
          : "";
      this.linkedInLink =
        config && config.channels && config.channels.linkedinUrl
          ? config.channels.linkedinUrl
          : "";
      this.youTubeLink =
        config && config.channels && config.channels.youtubeUrl
          ? config.channels.youtubeUrl
          : "";
      this.instaGramLink =
        config && config.channels && config.channels.instagramUrl
          ? config.channels.instagramUrl
          : "";
      this.emailAddress =
        config && config.whiteshop && config.whiteshop.emailAddress
          ? config.whiteshop.emailAddress
          : "";
      this.contactNumber =
        config && config.whiteshop && config.whiteshop.phoneNumber
          ? config.whiteshop.phoneNumber
          : "";
      this.seoContent = this.isSTL
        ? config.whiteshop && config.whiteshop.stl.seoContent
          ? config.whiteshop.stl.seoContent
          : ""
        : config.whiteshop && config.whiteshop.seoContent
        ? config.whiteshop.seoContent
        : "";
      this.footerContent = this.isSTL
        ? config.whiteshop && config.whiteshop.stl?.footerContent
          ? config.whiteshop.stl.footerContent
          : ""
        : config.whiteshop && config.whiteshop.footerContent
        ? config.whiteshop.footerContent
        : "";
      this.isAlternateFooter = config.whiteshop.isAlternateFooter;
    }
    this.iconRegistry.addSvgIcon(
      "facebook_new",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/facebook-square-brands.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "insta_new",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/instagram-brands.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "youtube_new",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/youtube-brands.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "linkedin_new",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/linkedin-in-brands.svg"
      )
    );
    this.iconRegistry.addSvgIcon(
      "twitter_new",
      this.sanitizer.bypassSecurityTrustResourceUrl(
        "assets/icons/twitter-brands.svg"
      )
    );
    if (this.is3D) {
      this.fbLogo = icons.footerIcons3D.fb;
      this.linkedInLogo = icons.footerIcons3D.linkedIn;
      this.instagramLogo = icons.footerIcons3D.instagram;
      this.youTubeLogo = icons.footerIcons3D.youTube;
      this.twitterLogo = icons.footerIcons3D.twitter;
      this.fbFooterLogoColored = icons.footerIcons3D.fbFooterColored;
      this.linkedInFooterLogoColored =
        icons.footerIcons3D.linkedInFooterColored;
      this.instagramFooterLogoColored =
        icons.footerIcons3D.instagramFooterColored;
      this.youTubeFooterLogoColored = icons.footerIcons3D.youTubeFooterColored;
      this.twitterFooterLogoColored = icons.footerIcons3D.twitterFooterColored;
    }
    this.setMapUrl(businessUnit);
  }
  ngAfterViewInit(): void {
    this.linkGenerator(this.footerText, true);
    this.linkGenerator(this.addresses[0]?.addressLine, false);
  }

  setupConfig(busSettings, comSettings) {
    const compareList = [
      "hideProfileFor3dBoard",
      "enableHeaderAndFooterFor3dBoard",
      "emailAddress",
      "pageLinks",
      "channels",
      "footerContent",
      "seoContent",
      "favIcon",
      "companyLogo",
      "footerText",
      "phoneNumber",
      "addresses",
      "stl",
      "isAlternateFooter",
    ];
    const mediaUrls = [
      "facebookUrl",
      "instagramUrl",
      "linkedinUrl",
      "youtubeUrl",
      "twitterUrl",
    ];
    compareList.forEach((ele) => {
      if (ele === "channels") {
        mediaUrls.forEach((url) => {
          if (
            busSettings[ele] &&
            busSettings[ele][url] !== undefined &&
            busSettings[ele][url] !== null &&
            busSettings[ele][url] !== ""
          ) {
            comSettings[ele][url] = busSettings[ele][url];
          }
        });
      } else {
        if (
          busSettings[ele] !== undefined &&
          busSettings[ele] !== null &&
          busSettings[ele] !== "" &&
          busSettings[ele].length !== 0
        ) {
          comSettings.whiteshop[ele] = busSettings[ele];
        }
      }
    });
    localStorage.setItem("busConfig", JSON.stringify(comSettings));
  }

  redirectPoweredBy() {
    window.open("https://shopconnect.live");
  }

  isMobileDevice() {
    return window.innerWidth <= 600;
  }

  isTabDevice() {
    return window.innerWidth > 600 && window.innerWidth <= 1200;
  }

  refineText(markdownText) {
    const htmlText = markdownText
      .replaceAll(" ", "&nbsp;<wbr>")
      .replaceAll("\n", "<br>")
      .replaceAll(
        /\[phone\]\((.*?)\)\((.*?)\)/gim,
        "<a class = 'nvc-link-mail-phone' href='tel:$1'>$2</a>"
      )
      .replaceAll(
        /\[link\]\((.*?)\)\((.*?)\)/gim,
        "<a class = 'nvc-link-mail-phone' target='_blank' href='$1'>$2</a>"
      )
      .replaceAll(
        /\[email\]\((.*?)\)/gim,
        "<a class = 'nvc-link-mail-phone' href='mailto:$1'>$1</a>"
      );
    return htmlText.trim();
  }

  isCartEnabled() {
    this.currentBusinessUnit = JSON.parse(
      sessionStorage.getItem("currentBusinessUnit")
        ? sessionStorage.getItem("currentBusinessUnit")
        : null
    );
    if (
      this.currentBusinessUnit &&
      this.currentBusinessUnit.settings &&
      this.currentBusinessUnit.settings.whiteshop
    ) {
      return this.currentBusinessUnit.settings.whiteshop
        .isSelectionsCartEnabled;
    } else {
      return false;
    }
  }
}
